/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormRecordDocumentFieldComponent } from '../../admin/form/form-record/fields/document/form-record-document-field.component';
/* eslint-enable */

export class FormRecordDocumentFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordDocumentFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
